// extracted by mini-css-extract-plugin
export default {"wrapper":"imageSlider_wrapper__JEZaN"};